<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.device_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.device_form.add_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.device_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>

        <form>
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.device_form.label_serial_number')"
                outlined
                v-model="input.serial_number"
              ></v-text-field>
            </div>
            <div class="select-box col-md-6">
              <v-select
                :items="readerTypes"
                v-model="input.reader_type"
                item-value="value"
                :label="$t('lang.admin.device_form.label_reader_type')"
                outlined
              ></v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.device_form.label_mac_address')"
                outlined
                v-model="input.mac_address"
              ></v-text-field>
            </div>
            <div class="select-box col-md-6">
              <v-select
                :items="locations"
                item-text="description"
                v-model="input.locationArea1_id"
                item-value="id"
                :label="$t('lang.admin.device_form.label_select_location')"
                outlined
              ></v-select>
            </div>

            <div class="select-box col-md-6">
              <v-select
                :items="workingModes"
                item-text="title"
                v-model="input.working_mode"
                item-value="value"
                :label="$t('lang.admin.device_form.label_working_mode')"
                outlined
              ></v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.location_form.btn_cancel")
              }}</v-btn>
              <bx-btn type="submit" color="primary" @click="submitForm">{{
                $t("lang.admin.device_form.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
let workingModes = [
  { value: 0, title: "Entry" },
  { value: 1, title: "Movement Exit" },
  { value: 2, title: "Handheld" },
  { value: 3, title: "Movement" },
  { value: 4, title: "Sale" },
  { value: 5, title: 'POS'},
  { value: 6, title: "Exit/Sale" },
  { value: 7, title: "Cabinet" },

];

let readerTypes = [
  { value: 0, text: "Normal" },
  { value: 1, text: "All" }
];

let Input = () => {
  return {
    serial_number: null,
    mac_address: null,
    working_mode: null,
    locationArea1_id: null,
    reader_type: null
  };
};

export default {
  name: "AddUserForm",
  data() {
    return {
      input: new Input(),
      errors: [],
      locations: [],
      workingModes: workingModes,
      readerTypes: readerTypes,
      success: {
        show: false,
        message: this.$t("lang.admin.device_form.success_add")
      },
      errorLabels: {
        serialNumber: this.$t("lang.admin.device_form.errors.serial_number"),
        macAddress: this.$t("lang.admin.device_form.errors.mac_address"),
        location: this.$t("lang.admin.device_form.errors.location"),
        failed: this.$t("lang.messages.label_something_went_wrong")
      }
    };
  },
  async mounted() {
    this.locations = await this.$api.area.list();
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.input);

      if (this.validate()) {
        try {
          let response = await this.$api.device.add(input);
          console.log(response);

          this.success.show = true;
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
        } finally {
          this.input = new Input();
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.input.serial_number) {
        error = true;
        this.errors.push(this.errorLabels.serialNumber);
      }

      if (!this.input.mac_address) {
        error = true;
        this.errors.push(this.errorLabels.macAddress);
      }

      if (!this.input.locationArea1_id) {
        error = true;
        this.errors.push(this.errorLabels.location);
      }

      if (error) {
        return false;
      }

      return true;
    }
  }
};
</script>
